/* Find Store URL tool — POSTs to the licensing backend's /lookup-shop
 * endpoint, renders the result panel (Copy button + Go to Activation link).
 *
 * On "Go to Activation" we:
 *   1. Smooth-scroll to the activate form anchor (configurable per section).
 *   2. Pre-fill the activate form's shop_domain input with the discovered URL
 *      via a custom event that the activate JS listens for.
 */
(function () {
  'use strict';

  function setLoading(form, isLoading) {
    var btn = form.querySelector('.csp-finder__submit');
    if (isLoading) {
      btn.disabled = true;
      btn.classList.add('is-loading');
    } else {
      btn.disabled = false;
      btn.classList.remove('is-loading');
    }
  }

  function renderError(result, message) {
    var err = document.createElement('div');
    err.className = 'csp-finder__error';
    err.textContent = message;
    result.replaceChildren(err);
  }

  function renderSuccess(result, shop) {
    var box = document.createElement('div');
    box.className = 'csp-finder__success';

    var title = document.createElement('div');
    title.className = 'csp-finder__success-title';
    var check = document.createElement('span');
    check.setAttribute('aria-hidden', 'true');
    check.textContent = '✓';
    title.appendChild(check);
    title.appendChild(document.createTextNode(' Found your original Shopify URL!'));
    box.appendChild(title);

    var row = document.createElement('div');
    row.className = 'csp-finder__success-row';

    var found = document.createElement('div');
    found.className = 'csp-finder__found';
    found.textContent = shop;
    found.setAttribute('role', 'textbox');
    found.setAttribute('aria-readonly', 'true');
    row.appendChild(found);

    var copyBtn = document.createElement('button');
    copyBtn.type = 'button';
    copyBtn.className = 'csp-finder__copy';
    copyBtn.textContent = 'Copy';
    copyBtn.addEventListener('click', function () {
      copyToClipboard(shop).then(function (ok) {
        if (!ok) return;
        var orig = copyBtn.textContent;
        copyBtn.textContent = 'Copied!';
        copyBtn.classList.add('is-copied');
        setTimeout(function () {
          copyBtn.textContent = orig;
          copyBtn.classList.remove('is-copied');
        }, 1500);
      });
    });
    row.appendChild(copyBtn);

    box.appendChild(row);

    var text = document.createElement('p');
    text.className = 'csp-finder__success-text';
    text.textContent = 'Copy the URL above and paste it into the activation form on this page.';
    box.appendChild(text);

    result.replaceChildren(box);

    /* Auto-fill the activate form's shop_domain input on the same page.
       The customer can still scroll up manually — we just save them the typing. */
    var shopInput = document.querySelector('.csp-activate__form input[name="shop_domain"]');
    if (shopInput && !shopInput.value) {
      shopInput.value = shop;
      shopInput.dispatchEvent(new Event('input', { bubbles: true }));
      shopInput.dispatchEvent(new Event('blur', { bubbles: true }));
    }
  }

  function copyToClipboard(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text).then(function () { return true; }, function () { return false; });
    }
    /* Fallback for older / non-secure contexts */
    return new Promise(function (resolve) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      try {
        var ok = document.execCommand('copy');
        document.body.removeChild(ta);
        resolve(ok);
      } catch (e) {
        document.body.removeChild(ta);
        resolve(false);
      }
    });
  }

  function attach(form) {
    var api = (form.dataset.api || '').replace(/\/+$/, '');
    var input = form.querySelector('input[name="domain"]');
    var result = form.querySelector('.csp-finder__result');

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var domain = (input.value || '').trim();
      if (!domain) {
        renderError(result, "Type your store's URL first.");
        input.focus();
        return;
      }
      if (!api) {
        renderError(result, 'This section is misconfigured — no backend URL set.');
        return;
      }

      setLoading(form, true);
      result.replaceChildren(); /* clear any prior result */

      var url = api + '/lookup-shop?domain=' + encodeURIComponent(domain);
      fetch(url, { method: 'GET', credentials: 'omit', cache: 'no-store' })
        .then(function (res) {
          return res.json().then(function (body) { return { status: res.status, body: body }; });
        })
        .then(function (r) {
          setLoading(form, false);
          if (r.status >= 200 && r.status < 300 && r.body && r.body.ok && r.body.shop) {
            renderSuccess(result, r.body.shop);
            return;
          }
          var msg = (r.body && (r.body.message || r.body.error))
            || 'We couldn\'t find a Shopify store at that URL.';
          renderError(result, msg);
        })
        .catch(function () {
          setLoading(form, false);
          renderError(result, 'Network error. Check your connection and try again.');
        });
    });
  }

  function init() {
    document.querySelectorAll('.csp-finder__form').forEach(attach);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();